export default {"src":"/_next/static/media/info-square.b115ccd7.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};